import { render, staticRenderFns } from "./subnet-detail.vue?vue&type=template&id=f48bbc02&scoped=true&"
import script from "./subnet-detail.vue?vue&type=script&lang=js&"
export * from "./subnet-detail.vue?vue&type=script&lang=js&"
import style0 from "./subnet-detail.vue?vue&type=style&index=0&id=f48bbc02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48bbc02",
  null
  
)

export default component.exports